<template>
	<b-modal
		v-model="show"
		:header="false"
		:footer="false"
		class="fade backdrop"
		@hide="close"
	>
		<div slot="default">
			<div class="iadsa-modal-header">
				<b-btn class="close btn btn-head-modal" @click="show=false">
					<i class="material-icons">close</i>
				</b-btn>
			</div>
			<div class="iadsa-modal-body">
				<h5>My profile</h5>
				<h2>Update your password</h2>
				<div class="form">
					<div class="row">
						<div class="col-xs-12">
							<label for="password">Current Password</label>
							<input
								v-model="currentPassword"
								:class="{ 'error': $v.currentPassword.$error }"
								type="password"
								name="password"
								class="form-control"
								placeholder="Current password"
							/>
						</div>
					</div>
					<br/>
					<div class="well">
						<div class="form-group">
							<div class="row">
								<div class="col-xs-12">
									<label for="password">New Password</label>
									<label
										v-if="$v.newPassword.$error && !$v.newPassword.required"
										class="label error pull-right"
									>Required</label>
									<label
										v-if="!$v.newConfirmPassword.sameAs && $v.newConfirmPassword.$error"
										class="label error pull-right"
									>Passwords must match</label>
									<input
										v-model="newPassword"
										:class="{ 'error': $v.newPassword.$error }"
										type="password"
										name="password"
										class="form-control"
										placeholder="Password (Must contain at least 6 characters)"
									/>
								</div>
							</div>
							<br/>
							<div class="row">
								<div class="col-xs-12">
									<label for="repeatPassword">Confirm new password</label>
									<label
										v-if="!$v.newConfirmPassword.required && $v.newConfirmPassword.$error"
										class="label error pull-right"
									>Required</label>
									<label
										v-if="!$v.newConfirmPassword.sameAs && $v.newConfirmPassword.$error"
										class="label error pull-right"
									>Passwords must match</label>
									<input
										v-model="newConfirmPassword"
										:class="{ 'error': $v.newConfirmPassword.$error }"
										type="password"
										name="repeatPassword"
										class="form-control"
										placeholder="Confirm new password"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div style="margin-top:30px">
					<b-btn type="danger" @click="show=false">
						Close
					</b-btn>
					<b-btn type="primary" @click="update">
						<strong>Save</strong>
					</b-btn>
				</div>
			</div>
		</div>
	</b-modal>
</template>

<style lang="less" scoped>
	.btn {
		margin-right: 5px;
	}
	.error {
		border-color: red;
		color: red;
	}
</style>

<script>
import { required, minLength, sameAs } from 'vuelidate/lib/validators';

export default {
	props: {
		showSecurityDetailsModal: {
			type: Boolean,
			required: true
		},
		details: {
			type: Object,
			default: () => ({})
		}
	},
	validations: {
		currentPassword: { required, minLength: minLength(6) },
		newPassword: { required, minLength: minLength(6) },
		newConfirmPassword: { required, sameAsPassword: sameAs('newPassword') }
	},
	data() {
		return {
			show: false,
			currentPassword: null,
			newPassword: null,
			newConfirmPassword: null
		};
	},
	watch: {
		showSecurityDetailsModal() {
			this.show = this.showSecurityDetailsModal;
		}
	},
	methods: {
		close() {
			this.$emit('closeSecurityDetailsModal');
		},
		update() {
			if (this.$v.$invalid) {
				this.$v.$touch();
			} else {
				this.$emit('updateSecurityDetails', {
					current_password: this.currentPassword,
					new_password: this.newPassword
				});
				this.currentPassword = null;
				this.newPassword = null;
				this.newConfirmPassword = null;
			}
		}
	}
};
</script>
